/* Central clinic / NAP (Name-Address-Phone) data.
   Written in CommonJS so it can be shared by both the React app (webpack
   import) and the Node build-time prerender script (require). */

const SITE_URL = 'https://siddhayuayurvedicclinic.com';

const PHONE_DISPLAY = '90289 23930';
const PHONE_E164 = '+919028923930';
const WHATSAPP_NUMBER = '919028923930';

function waLink(message) {
  const text = message ||
    'Hello Siddhayu Ayurvedic Clinic! I found your website and would like to book a consultation.';
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

const clinic = {
  siteUrl: SITE_URL,
  name: 'Siddhayu Ayurvedic Clinic & Panchakarma Centre',
  shortName: 'Siddhayu Ayurveda',
  nameHi: 'सिद्धायु आयुर्वेद',
  doctor: 'Dr. Ankit Dineshchandra Sahu',
  doctorShort: 'Dr. Ankit Sahu',
  qualification: 'BAMS',
  registration: 'MCIM Reg. I-124028-A',
  phoneDisplay: PHONE_DISPLAY,
  phoneE164: PHONE_E164,
  whatsappNumber: WHATSAPP_NUMBER,
  email: '',
  rating: '4.9',
  reviewCount: '22',
  address: {
    street: 'Sai Shradha Apt, Shop No. 5, Opposite Sundar Nagar, Vijay Nagar, Nallasopara East',
    locality: 'Nala Sopara',
    region: 'Maharashtra',
    postalCode: '401209',
    country: 'IN',
  },
  geo: { lat: 19.4266925, lng: 72.825433 },
  hours: 'Mon–Sat: 10:30 AM – 9:30 PM · Sunday: 5:00 PM – 9:30 PM',
  areasServed: [
    'Nala Sopara', 'Nallasopara East', 'Nallasopara West', 'Vasai', 'Virar',
    'Vasai-Virar', 'Naigaon', 'Palghar', 'Mira Road', 'Bhayandar',
  ],
  waLink,
};

module.exports = clinic;
